import dayjs from "dayjs";
import { ILocalOrderState } from "shared/atoms/localOrder.atom";

//Update modified field (date), on local order modification
export default (currentLocalOrder: ILocalOrderState): ILocalOrderState => {
  const newState = { ...currentLocalOrder };
  newState.modified = dayjs().toDate();
  return { ...newState };
};
